import { PixelateFilter as PixiPixelateFilter } from 'pixi-filters'
import { EffectState } from '@/pixi/filters/types'
import AudioIntensityAnalyzer from '@/audio/AudioIntensityAnalyzer'
import { SeratoFilter } from '@/pixi/filters/types'
import useAudioEngine from '@/composables/UseAudioEngine'
const { audioBackgroundIntensity } = useAudioEngine()

export class PixelateFilter extends PixiPixelateFilter implements SeratoFilter {
  private readonly maxPixelSize = 75
  
  constructor (private effectState: EffectState) {
    super()
  }

  public updateUniforms () {
    const audioIntensity = this.effectState.audioReactivityEnabled
      ? AudioIntensityAnalyzer.getAudioIntensity(this.uniforms.audioFrequencyData, audioBackgroundIntensity.value) : 1

    // get pixel size based on audio intensity, effect intensity and max pixel size
    const pixelSize = Math.floor(audioIntensity * this.effectState.intensity * this.maxPixelSize)
    this.size = pixelSize === 0 ? 1 : pixelSize
  }
}
